// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZJfC","type":"styles_type__34ovO","choices":"styles_choices__1402R"};